import axios from './axios';
import SETTINGS from '../settings'
export default {
    getProjects(params, cb) {
        axios.get(`${SETTINGS.API_BASE_PATH}/project`, {params}).then(response => {
            cb(response.data)
        }).catch(e => {
            console.log(e)
        })
    },
}